import { useEffect } from 'react';
import { useReportCtx } from '../report-ctx';
import { ReportFormApplyFn } from './useReport';

/**
 * Registers a form apply function on the nearest report context.
 * The result table sits outside Formik/RHF, so column filters call this instead of reverse-syncing context into the form.
 */
export function useRegisterReportFormApply(apply: ReportFormApplyFn) {
  const { registerFormApply } = useReportCtx();

  useEffect(() => {
    registerFormApply(apply);
    return () => registerFormApply(null);
  }, [apply, registerFormApply]);
}
